/* Options:
Date: 2021-05-31 07:08:55
Version: 5.60
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:58306

//GlobalNamespace:
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AdobePostResponse = /** @class */ (function () {
    function AdobePostResponse(init) {
        Object.assign(this, init);
    }
    return AdobePostResponse;
}());
export { AdobePostResponse };
var ApiKey = /** @class */ (function () {
    function ApiKey(init) {
        Object.assign(this, init);
    }
    return ApiKey;
}());
export { ApiKey };
var WarehouseMonthlyPerformance = /** @class */ (function () {
    function WarehouseMonthlyPerformance(init) {
        Object.assign(this, init);
    }
    return WarehouseMonthlyPerformance;
}());
export { WarehouseMonthlyPerformance };
var AssetAllocationView = /** @class */ (function () {
    function AssetAllocationView(init) {
        Object.assign(this, init);
    }
    return AssetAllocationView;
}());
export { AssetAllocationView };
var PortfolioPosition = /** @class */ (function () {
    function PortfolioPosition(init) {
        Object.assign(this, init);
    }
    return PortfolioPosition;
}());
export { PortfolioPosition };
var AssetAllocationPoints = /** @class */ (function () {
    function AssetAllocationPoints(init) {
        Object.assign(this, init);
    }
    return AssetAllocationPoints;
}());
export { AssetAllocationPoints };
var Portfolio = /** @class */ (function () {
    function Portfolio(init) {
        Object.assign(this, init);
    }
    return Portfolio;
}());
export { Portfolio };
var RiskProfile = /** @class */ (function () {
    function RiskProfile(init) {
        Object.assign(this, init);
    }
    return RiskProfile;
}());
export { RiskProfile };
var AnnualisedPerformance = /** @class */ (function () {
    function AnnualisedPerformance(init) {
        Object.assign(this, init);
    }
    return AnnualisedPerformance;
}());
export { AnnualisedPerformance };
var SeriesCollection = /** @class */ (function () {
    function SeriesCollection(init) {
        Object.assign(this, init);
    }
    return SeriesCollection;
}());
export { SeriesCollection };
var CumulativePerformanceView = /** @class */ (function () {
    function CumulativePerformanceView(init) {
        Object.assign(this, init);
    }
    return CumulativePerformanceView;
}());
export { CumulativePerformanceView };
var WarehousePerformance = /** @class */ (function () {
    function WarehousePerformance(init) {
        Object.assign(this, init);
    }
    return WarehousePerformance;
}());
export { WarehousePerformance };
var Fund = /** @class */ (function () {
    function Fund(init) {
        Object.assign(this, init);
    }
    return Fund;
}());
export { Fund };
var WarehouseFundFactSheetSnapshot = /** @class */ (function () {
    function WarehouseFundFactSheetSnapshot(init) {
        Object.assign(this, init);
    }
    return WarehouseFundFactSheetSnapshot;
}());
export { WarehouseFundFactSheetSnapshot };
var PortfolioView = /** @class */ (function () {
    function PortfolioView(init) {
        Object.assign(this, init);
    }
    return PortfolioView;
}());
export { PortfolioView };
var PortfolioWeightView = /** @class */ (function () {
    function PortfolioWeightView(init) {
        Object.assign(this, init);
    }
    return PortfolioWeightView;
}());
export { PortfolioWeightView };
var InvestmentAccount = /** @class */ (function () {
    function InvestmentAccount(init) {
        Object.assign(this, init);
    }
    return InvestmentAccount;
}());
export { InvestmentAccount };
var AppearanceSchema = /** @class */ (function () {
    function AppearanceSchema(init) {
        Object.assign(this, init);
    }
    return AppearanceSchema;
}());
export { AppearanceSchema };
var AppearanceSettings = /** @class */ (function () {
    function AppearanceSettings(init) {
        Object.assign(this, init);
    }
    return AppearanceSettings;
}());
export { AppearanceSettings };
var PartnerDefaultSettings = /** @class */ (function () {
    function PartnerDefaultSettings(init) {
        Object.assign(this, init);
    }
    return PartnerDefaultSettings;
}());
export { PartnerDefaultSettings };
var PartnerContactDetails = /** @class */ (function () {
    function PartnerContactDetails(init) {
        Object.assign(this, init);
    }
    return PartnerContactDetails;
}());
export { PartnerContactDetails };
var PartnerSettings = /** @class */ (function () {
    function PartnerSettings(init) {
        Object.assign(this, init);
    }
    return PartnerSettings;
}());
export { PartnerSettings };
var ClientGoalsView = /** @class */ (function () {
    function ClientGoalsView(init) {
        Object.assign(this, init);
    }
    return ClientGoalsView;
}());
export { ClientGoalsView };
var ClientSearchView = /** @class */ (function () {
    function ClientSearchView(init) {
        Object.assign(this, init);
    }
    return ClientSearchView;
}());
export { ClientSearchView };
var ClientView = /** @class */ (function () {
    function ClientView(init) {
        Object.assign(this, init);
    }
    return ClientView;
}());
export { ClientView };
var CustomPortfolio = /** @class */ (function () {
    function CustomPortfolio(init) {
        Object.assign(this, init);
    }
    return CustomPortfolio;
}());
export { CustomPortfolio };
var CustomPortfolioWeight = /** @class */ (function () {
    function CustomPortfolioWeight(init) {
        Object.assign(this, init);
    }
    return CustomPortfolioWeight;
}());
export { CustomPortfolioWeight };
var AaBalanceView = /** @class */ (function () {
    function AaBalanceView(init) {
        Object.assign(this, init);
    }
    return AaBalanceView;
}());
export { AaBalanceView };
var HistoricalReturn = /** @class */ (function () {
    function HistoricalReturn(init) {
        Object.assign(this, init);
    }
    return HistoricalReturn;
}());
export { HistoricalReturn };
var DrawdownReturn = /** @class */ (function () {
    function DrawdownReturn(init) {
        Object.assign(this, init);
    }
    return DrawdownReturn;
}());
export { DrawdownReturn };
var HistoricalStats = /** @class */ (function () {
    function HistoricalStats(init) {
        Object.assign(this, init);
    }
    return HistoricalStats;
}());
export { HistoricalStats };
var MinMaxReturn = /** @class */ (function () {
    function MinMaxReturn(init) {
        Object.assign(this, init);
    }
    return MinMaxReturn;
}());
export { MinMaxReturn };
var ProjectedView = /** @class */ (function () {
    function ProjectedView(init) {
        Object.assign(this, init);
    }
    return ProjectedView;
}());
export { ProjectedView };
var Partner = /** @class */ (function () {
    function Partner(init) {
        Object.assign(this, init);
    }
    return Partner;
}());
export { Partner };
var Theme = /** @class */ (function () {
    function Theme(init) {
        Object.assign(this, init);
    }
    return Theme;
}());
export { Theme };
var Location = /** @class */ (function () {
    function Location(init) {
        Object.assign(this, init);
    }
    return Location;
}());
export { Location };
var SignGeoLocation = /** @class */ (function () {
    function SignGeoLocation(init) {
        Object.assign(this, init);
    }
    return SignGeoLocation;
}());
export { SignGeoLocation };
var SignatureDto = /** @class */ (function () {
    function SignatureDto(init) {
        Object.assign(this, init);
    }
    return SignatureDto;
}());
export { SignatureDto };
var GetRiskNeedResponse = /** @class */ (function () {
    function GetRiskNeedResponse(init) {
        Object.assign(this, init);
    }
    return GetRiskNeedResponse;
}());
export { GetRiskNeedResponse };
var GetRiskAbilityResponse = /** @class */ (function () {
    function GetRiskAbilityResponse(init) {
        Object.assign(this, init);
    }
    return GetRiskAbilityResponse;
}());
export { GetRiskAbilityResponse };
var GetRiskToleranceResponse = /** @class */ (function () {
    function GetRiskToleranceResponse(init) {
        Object.assign(this, init);
    }
    return GetRiskToleranceResponse;
}());
export { GetRiskToleranceResponse };
var GetGoalRiskProfileResponse = /** @class */ (function () {
    function GetGoalRiskProfileResponse(init) {
        Object.assign(this, init);
    }
    return GetGoalRiskProfileResponse;
}());
export { GetGoalRiskProfileResponse };
var GoalRiskProfile = /** @class */ (function () {
    function GoalRiskProfile(init) {
        Object.assign(this, init);
    }
    return GoalRiskProfile;
}());
export { GoalRiskProfile };
var IncomeView = /** @class */ (function () {
    function IncomeView(init) {
        Object.assign(this, init);
    }
    return IncomeView;
}());
export { IncomeView };
var GetIncomeCashFlowResponse = /** @class */ (function () {
    function GetIncomeCashFlowResponse(init) {
        Object.assign(this, init);
    }
    return GetIncomeCashFlowResponse;
}());
export { GetIncomeCashFlowResponse };
var GetProjectionResponse = /** @class */ (function () {
    function GetProjectionResponse(init) {
        Object.assign(this, init);
    }
    return GetProjectionResponse;
}());
export { GetProjectionResponse };
export var GoalTypeEnum;
(function (GoalTypeEnum) {
    GoalTypeEnum["PostRetirement"] = "PostRetirement";
    GoalTypeEnum["PreRetirement"] = "PreRetirement";
    GoalTypeEnum["Emergency"] = "Emergency";
    GoalTypeEnum["Education"] = "Education";
    GoalTypeEnum["GeneralInvesting"] = "GeneralInvesting";
    GoalTypeEnum["Target"] = "Target";
    GoalTypeEnum["Wedding"] = "Wedding";
    GoalTypeEnum["House"] = "House";
})(GoalTypeEnum || (GoalTypeEnum = {}));
var GoalInfo = /** @class */ (function () {
    function GoalInfo(init) {
        Object.assign(this, init);
    }
    return GoalInfo;
}());
export { GoalInfo };
var GetContributionCashFlowResponse = /** @class */ (function () {
    function GetContributionCashFlowResponse(init) {
        Object.assign(this, init);
    }
    return GetContributionCashFlowResponse;
}());
export { GetContributionCashFlowResponse };
// @Route("/projections/contribution")
var GetContributionCashFlowRequest = /** @class */ (function () {
    function GetContributionCashFlowRequest(init) {
        Object.assign(this, init);
    }
    GetContributionCashFlowRequest.prototype.createResponse = function () { return new GetContributionCashFlowResponse(); };
    GetContributionCashFlowRequest.prototype.getTypeName = function () { return 'GetContributionCashFlowRequest'; };
    return GetContributionCashFlowRequest;
}());
export { GetContributionCashFlowRequest };
// @Route("/projections/income")
var GetIncomeCashFlowRequest = /** @class */ (function () {
    function GetIncomeCashFlowRequest(init) {
        Object.assign(this, init);
    }
    GetIncomeCashFlowRequest.prototype.createResponse = function () { return new GetIncomeCashFlowResponse(); };
    GetIncomeCashFlowRequest.prototype.getTypeName = function () { return 'GetIncomeCashFlowRequest'; };
    return GetIncomeCashFlowRequest;
}());
export { GetIncomeCashFlowRequest };
// @Route("/projections/balances")
var GetProjection = /** @class */ (function () {
    function GetProjection(init) {
        Object.assign(this, init);
    }
    GetProjection.prototype.createResponse = function () { return new GetProjectionResponse(); };
    GetProjection.prototype.getTypeName = function () { return 'GetProjection'; };
    return GetProjection;
}());
export { GetProjection };
var ClientGoalV2 = /** @class */ (function () {
    function ClientGoalV2(init) {
        Object.assign(this, init);
    }
    return ClientGoalV2;
}());
export { ClientGoalV2 };
var ViewProposalsV2 = /** @class */ (function () {
    function ViewProposalsV2(init) {
        Object.assign(this, init);
    }
    return ViewProposalsV2;
}());
export { ViewProposalsV2 };
var ViewProposalsAudit = /** @class */ (function () {
    function ViewProposalsAudit(init) {
        Object.assign(this, init);
    }
    return ViewProposalsAudit;
}());
export { ViewProposalsAudit };
var ProposalsV2 = /** @class */ (function () {
    function ProposalsV2(init) {
        Object.assign(this, init);
    }
    return ProposalsV2;
}());
export { ProposalsV2 };
var Client = /** @class */ (function () {
    function Client(init) {
        Object.assign(this, init);
    }
    return Client;
}());
export { Client };
var MinMaxView = /** @class */ (function () {
    function MinMaxView(init) {
        Object.assign(this, init);
    }
    return MinMaxView;
}());
export { MinMaxView };
var ProposalView = /** @class */ (function () {
    function ProposalView(init) {
        Object.assign(this, init);
    }
    return ProposalView;
}());
export { ProposalView };
var FileContainer = /** @class */ (function () {
    function FileContainer(init) {
        Object.assign(this, init);
    }
    return FileContainer;
}());
export { FileContainer };
var Signature = /** @class */ (function () {
    function Signature(init) {
        Object.assign(this, init);
    }
    return Signature;
}());
export { Signature };
var ClientDocument = /** @class */ (function () {
    function ClientDocument(init) {
        Object.assign(this, init);
    }
    return ClientDocument;
}());
export { ClientDocument };
var ProjectedBalance = /** @class */ (function () {
    function ProjectedBalance(init) {
        Object.assign(this, init);
    }
    return ProjectedBalance;
}());
export { ProjectedBalance };
var ProjectedReturnSeriesData = /** @class */ (function () {
    function ProjectedReturnSeriesData(init) {
        Object.assign(this, init);
    }
    return ProjectedReturnSeriesData;
}());
export { ProjectedReturnSeriesData };
var CashFlow = /** @class */ (function () {
    function CashFlow(init) {
        Object.assign(this, init);
    }
    return CashFlow;
}());
export { CashFlow };
var GoalType = /** @class */ (function () {
    function GoalType(init) {
        Object.assign(this, init);
    }
    return GoalType;
}());
export { GoalType };
var ClientGoalResults = /** @class */ (function () {
    function ClientGoalResults(init) {
        Object.assign(this, init);
    }
    return ClientGoalResults;
}());
export { ClientGoalResults };
var UserPartners = /** @class */ (function () {
    function UserPartners(init) {
        Object.assign(this, init);
    }
    return UserPartners;
}());
export { UserPartners };
// @DataContract
var ResponseError = /** @class */ (function () {
    function ResponseError(init) {
        Object.assign(this, init);
    }
    return ResponseError;
}());
export { ResponseError };
// @DataContract
var ResponseStatus = /** @class */ (function () {
    function ResponseStatus(init) {
        Object.assign(this, init);
    }
    return ResponseStatus;
}());
export { ResponseStatus };
export var FeeName;
(function (FeeName) {
    FeeName["Advisory"] = "Advisory";
    FeeName["Platform"] = "Platform";
    FeeName["FundFee"] = "FundFee";
})(FeeName || (FeeName = {}));
export var FeeType;
(function (FeeType) {
    FeeType["SlidingScale"] = "SlidingScale";
    FeeType["Single"] = "Single";
})(FeeType || (FeeType = {}));
var FeeBracket = /** @class */ (function () {
    function FeeBracket(init) {
        Object.assign(this, init);
    }
    return FeeBracket;
}());
export { FeeBracket };
var FeeTable = /** @class */ (function () {
    function FeeTable(init) {
        Object.assign(this, init);
    }
    return FeeTable;
}());
export { FeeTable };
var PortfolioFeesTable = /** @class */ (function () {
    function PortfolioFeesTable(init) {
        Object.assign(this, init);
    }
    return PortfolioFeesTable;
}());
export { PortfolioFeesTable };
var FeeInfo = /** @class */ (function () {
    function FeeInfo(init) {
        Object.assign(this, init);
    }
    return FeeInfo;
}());
export { FeeInfo };
var CalcFee = /** @class */ (function () {
    function CalcFee(init) {
        Object.assign(this, init);
    }
    return CalcFee;
}());
export { CalcFee };
var GraphReturn = /** @class */ (function () {
    function GraphReturn(init) {
        Object.assign(this, init);
    }
    return GraphReturn;
}());
export { GraphReturn };
var Auth0User = /** @class */ (function () {
    function Auth0User(init) {
        Object.assign(this, init);
    }
    return Auth0User;
}());
export { Auth0User };
var UserActivity = /** @class */ (function () {
    function UserActivity(init) {
        Object.assign(this, init);
    }
    return UserActivity;
}());
export { UserActivity };
var UserAuth = /** @class */ (function () {
    function UserAuth(init) {
        Object.assign(this, init);
    }
    return UserAuth;
}());
export { UserAuth };
var CustomUserAuth = /** @class */ (function (_super) {
    __extends(CustomUserAuth, _super);
    function CustomUserAuth(init) {
        var _this = _super.call(this, init) || this;
        Object.assign(_this, init);
        return _this;
    }
    return CustomUserAuth;
}(UserAuth));
export { CustomUserAuth };
var ProduceTestReportResponse = /** @class */ (function () {
    function ProduceTestReportResponse(init) {
        Object.assign(this, init);
    }
    return ProduceTestReportResponse;
}());
export { ProduceTestReportResponse };
var PostAnimationResponse = /** @class */ (function () {
    function PostAnimationResponse(init) {
        Object.assign(this, init);
    }
    return PostAnimationResponse;
}());
export { PostAnimationResponse };
var PostPlanToAdobeResponse = /** @class */ (function () {
    function PostPlanToAdobeResponse(init) {
        Object.assign(this, init);
    }
    return PostPlanToAdobeResponse;
}());
export { PostPlanToAdobeResponse };
var GetUserApiKeysResponse = /** @class */ (function () {
    function GetUserApiKeysResponse(init) {
        Object.assign(this, init);
    }
    return GetUserApiKeysResponse;
}());
export { GetUserApiKeysResponse };
var GetInvestmentAccountsResponse = /** @class */ (function () {
    function GetInvestmentAccountsResponse(init) {
        Object.assign(this, init);
    }
    return GetInvestmentAccountsResponse;
}());
export { GetInvestmentAccountsResponse };
var GetClientsV2Response = /** @class */ (function () {
    function GetClientsV2Response(init) {
        Object.assign(this, init);
    }
    return GetClientsV2Response;
}());
export { GetClientsV2Response };
var GetClientV2Response = /** @class */ (function () {
    function GetClientV2Response(init) {
        Object.assign(this, init);
    }
    return GetClientV2Response;
}());
export { GetClientV2Response };
var CreateOrUpdateClientV2Response = /** @class */ (function () {
    function CreateOrUpdateClientV2Response(init) {
        Object.assign(this, init);
    }
    return CreateOrUpdateClientV2Response;
}());
export { CreateOrUpdateClientV2Response };
var GetCustomPortfoliosResponse = /** @class */ (function () {
    function GetCustomPortfoliosResponse(init) {
        Object.assign(this, init);
    }
    return GetCustomPortfoliosResponse;
}());
export { GetCustomPortfoliosResponse };
var GetCustomPortfolioResponse = /** @class */ (function () {
    function GetCustomPortfolioResponse(init) {
        Object.assign(this, init);
    }
    return GetCustomPortfolioResponse;
}());
export { GetCustomPortfolioResponse };
var CalculateCustomPortfolioStatsResponse = /** @class */ (function () {
    function CalculateCustomPortfolioStatsResponse(init) {
        Object.assign(this, init);
    }
    return CalculateCustomPortfolioStatsResponse;
}());
export { CalculateCustomPortfolioStatsResponse };
var CreateOrUpdateCustomPortfolioResponse = /** @class */ (function () {
    function CreateOrUpdateCustomPortfolioResponse(init) {
        Object.assign(this, init);
    }
    return CreateOrUpdateCustomPortfolioResponse;
}());
export { CreateOrUpdateCustomPortfolioResponse };
var SendMailTemplateResponse = /** @class */ (function () {
    function SendMailTemplateResponse(init) {
        Object.assign(this, init);
    }
    return SendMailTemplateResponse;
}());
export { SendMailTemplateResponse };
var SendQuickErrorMailTemplateResponse = /** @class */ (function () {
    function SendQuickErrorMailTemplateResponse(init) {
        Object.assign(this, init);
    }
    return SendQuickErrorMailTemplateResponse;
}());
export { SendQuickErrorMailTemplateResponse };
var GetHistoricalResponse = /** @class */ (function () {
    function GetHistoricalResponse(init) {
        Object.assign(this, init);
    }
    return GetHistoricalResponse;
}());
export { GetHistoricalResponse };
var GetHistoricalCashFlowResponse = /** @class */ (function () {
    function GetHistoricalCashFlowResponse(init) {
        Object.assign(this, init);
    }
    return GetHistoricalCashFlowResponse;
}());
export { GetHistoricalCashFlowResponse };
var GetPartnersResponseM = /** @class */ (function () {
    function GetPartnersResponseM(init) {
        Object.assign(this, init);
    }
    return GetPartnersResponseM;
}());
export { GetPartnersResponseM };
var GetPortfoliosResponseM = /** @class */ (function () {
    function GetPortfoliosResponseM(init) {
        Object.assign(this, init);
    }
    return GetPortfoliosResponseM;
}());
export { GetPortfoliosResponseM };
var ChangePartnerResponseM = /** @class */ (function () {
    function ChangePartnerResponseM(init) {
        Object.assign(this, init);
    }
    return ChangePartnerResponseM;
}());
export { ChangePartnerResponseM };
var GetThemesResponseM = /** @class */ (function () {
    function GetThemesResponseM(init) {
        Object.assign(this, init);
    }
    return GetThemesResponseM;
}());
export { GetThemesResponseM };
var UpdateThemeResponseM = /** @class */ (function () {
    function UpdateThemeResponseM(init) {
        Object.assign(this, init);
    }
    return UpdateThemeResponseM;
}());
export { UpdateThemeResponseM };
var GetProposalsV2Response = /** @class */ (function () {
    function GetProposalsV2Response(init) {
        Object.assign(this, init);
    }
    return GetProposalsV2Response;
}());
export { GetProposalsV2Response };
var GetProposalsAuditV2Response = /** @class */ (function () {
    function GetProposalsAuditV2Response(init) {
        Object.assign(this, init);
    }
    return GetProposalsAuditV2Response;
}());
export { GetProposalsAuditV2Response };
var CreateClientProposalsV2Response = /** @class */ (function () {
    function CreateClientProposalsV2Response(init) {
        Object.assign(this, init);
    }
    return CreateClientProposalsV2Response;
}());
export { CreateClientProposalsV2Response };
var UpdateProposalStatusV2Response = /** @class */ (function () {
    function UpdateProposalStatusV2Response(init) {
        Object.assign(this, init);
    }
    return UpdateProposalStatusV2Response;
}());
export { UpdateProposalStatusV2Response };
var DeleteProposalsV2Response = /** @class */ (function () {
    function DeleteProposalsV2Response(init) {
        Object.assign(this, init);
    }
    return DeleteProposalsV2Response;
}());
export { DeleteProposalsV2Response };
var GetClientProposalsV2Response = /** @class */ (function () {
    function GetClientProposalsV2Response(init) {
        Object.assign(this, init);
    }
    return GetClientProposalsV2Response;
}());
export { GetClientProposalsV2Response };
var GetClientProposalGoalV2Response = /** @class */ (function () {
    function GetClientProposalGoalV2Response(init) {
        Object.assign(this, init);
    }
    return GetClientProposalGoalV2Response;
}());
export { GetClientProposalGoalV2Response };
var SignProposalsV2Response = /** @class */ (function () {
    function SignProposalsV2Response(init) {
        Object.assign(this, init);
    }
    return SignProposalsV2Response;
}());
export { SignProposalsV2Response };
var DownloadProposalPlanResponse = /** @class */ (function () {
    function DownloadProposalPlanResponse(init) {
        Object.assign(this, init);
    }
    return DownloadProposalPlanResponse;
}());
export { DownloadProposalPlanResponse };
var GetMddDataResponse = /** @class */ (function () {
    function GetMddDataResponse(init) {
        Object.assign(this, init);
    }
    return GetMddDataResponse;
}());
export { GetMddDataResponse };
var GetProjectionStatsResponse = /** @class */ (function () {
    function GetProjectionStatsResponse(init) {
        Object.assign(this, init);
    }
    return GetProjectionStatsResponse;
}());
export { GetProjectionStatsResponse };
var SaveProjectionResponse = /** @class */ (function () {
    function SaveProjectionResponse(init) {
        Object.assign(this, init);
    }
    return SaveProjectionResponse;
}());
export { SaveProjectionResponse };
var GetSavedProjectionResponse = /** @class */ (function () {
    function GetSavedProjectionResponse(init) {
        Object.assign(this, init);
    }
    return GetSavedProjectionResponse;
}());
export { GetSavedProjectionResponse };
var GetProposalsResponse = /** @class */ (function () {
    function GetProposalsResponse(init) {
        Object.assign(this, init);
    }
    return GetProposalsResponse;
}());
export { GetProposalsResponse };
var GetClientDocumentsResponse = /** @class */ (function () {
    function GetClientDocumentsResponse(init) {
        Object.assign(this, init);
    }
    return GetClientDocumentsResponse;
}());
export { GetClientDocumentsResponse };
var SendFeedbackResponse = /** @class */ (function () {
    function SendFeedbackResponse(init) {
        Object.assign(this, init);
    }
    return SendFeedbackResponse;
}());
export { SendFeedbackResponse };
var GenerateReportResponse = /** @class */ (function () {
    function GenerateReportResponse(init) {
        Object.assign(this, init);
    }
    return GenerateReportResponse;
}());
export { GenerateReportResponse };
var GetReportDataResponse = /** @class */ (function () {
    function GetReportDataResponse(init) {
        Object.assign(this, init);
    }
    return GetReportDataResponse;
}());
export { GetReportDataResponse };
var CalculatePortfolioAaResponse = /** @class */ (function () {
    function CalculatePortfolioAaResponse(init) {
        Object.assign(this, init);
    }
    return CalculatePortfolioAaResponse;
}());
export { CalculatePortfolioAaResponse };
var CalculatePortfolioStatsResponse = /** @class */ (function () {
    function CalculatePortfolioStatsResponse(init) {
        Object.assign(this, init);
    }
    return CalculatePortfolioStatsResponse;
}());
export { CalculatePortfolioStatsResponse };
var UpdatePortfolioStatsBasedOnAaResponse = /** @class */ (function () {
    function UpdatePortfolioStatsBasedOnAaResponse(init) {
        Object.assign(this, init);
    }
    return UpdatePortfolioStatsBasedOnAaResponse;
}());
export { UpdatePortfolioStatsBasedOnAaResponse };
var CalculateSustainableIncomeResponse = /** @class */ (function () {
    function CalculateSustainableIncomeResponse(init) {
        Object.assign(this, init);
    }
    return CalculateSustainableIncomeResponse;
}());
export { CalculateSustainableIncomeResponse };
var CalculateOptimalPortfolioResponse = /** @class */ (function () {
    function CalculateOptimalPortfolioResponse(init) {
        Object.assign(this, init);
    }
    return CalculateOptimalPortfolioResponse;
}());
export { CalculateOptimalPortfolioResponse };
var CalculateProjectedBalancesResponse = /** @class */ (function () {
    function CalculateProjectedBalancesResponse(init) {
        Object.assign(this, init);
    }
    return CalculateProjectedBalancesResponse;
}());
export { CalculateProjectedBalancesResponse };
var CalculateProjectedReturnsResponse = /** @class */ (function () {
    function CalculateProjectedReturnsResponse(init) {
        Object.assign(this, init);
    }
    return CalculateProjectedReturnsResponse;
}());
export { CalculateProjectedReturnsResponse };
// @Route("/calculator/projectedReturnsv1")
var CalculateProjectedReturns = /** @class */ (function () {
    function CalculateProjectedReturns(init) {
        Object.assign(this, init);
    }
    CalculateProjectedReturns.prototype.createResponse = function () { return new CalculateProjectedReturnsResponse(); };
    CalculateProjectedReturns.prototype.getTypeName = function () { return 'CalculateProjectedReturns'; };
    return CalculateProjectedReturns;
}());
export { CalculateProjectedReturns };
var GetClientsResponse = /** @class */ (function () {
    function GetClientsResponse(init) {
        Object.assign(this, init);
    }
    return GetClientsResponse;
}());
export { GetClientsResponse };
var GetClientResponse = /** @class */ (function () {
    function GetClientResponse(init) {
        Object.assign(this, init);
    }
    return GetClientResponse;
}());
export { GetClientResponse };
var CreateOrUpdateClientResponse = /** @class */ (function () {
    function CreateOrUpdateClientResponse(init) {
        Object.assign(this, init);
    }
    return CreateOrUpdateClientResponse;
}());
export { CreateOrUpdateClientResponse };
var CreatePostRetirementClientResponse = /** @class */ (function () {
    function CreatePostRetirementClientResponse(init) {
        Object.assign(this, init);
    }
    return CreatePostRetirementClientResponse;
}());
export { CreatePostRetirementClientResponse };
var GetGoalTypesResponse = /** @class */ (function () {
    function GetGoalTypesResponse(init) {
        Object.assign(this, init);
    }
    return GetGoalTypesResponse;
}());
export { GetGoalTypesResponse };
var UpdateClientGoalsV2Response = /** @class */ (function () {
    function UpdateClientGoalsV2Response(init) {
        Object.assign(this, init);
    }
    return UpdateClientGoalsV2Response;
}());
export { UpdateClientGoalsV2Response };
var GetClientGoalsV2Response = /** @class */ (function () {
    function GetClientGoalsV2Response(init) {
        Object.assign(this, init);
    }
    return GetClientGoalsV2Response;
}());
export { GetClientGoalsV2Response };
var GetClientGoalsResponse = /** @class */ (function () {
    function GetClientGoalsResponse(init) {
        Object.assign(this, init);
    }
    return GetClientGoalsResponse;
}());
export { GetClientGoalsResponse };
var CreateGoalResponse = /** @class */ (function () {
    function CreateGoalResponse(init) {
        Object.assign(this, init);
    }
    return CreateGoalResponse;
}());
export { CreateGoalResponse };
var UpdateGoalResultsStatusResponse = /** @class */ (function () {
    function UpdateGoalResultsStatusResponse(init) {
        Object.assign(this, init);
    }
    return UpdateGoalResultsStatusResponse;
}());
export { UpdateGoalResultsStatusResponse };
var RetirementGoalResponse = /** @class */ (function () {
    function RetirementGoalResponse(init) {
        Object.assign(this, init);
    }
    return RetirementGoalResponse;
}());
export { RetirementGoalResponse };
var GetRiskProfilesResponse = /** @class */ (function () {
    function GetRiskProfilesResponse(init) {
        Object.assign(this, init);
    }
    return GetRiskProfilesResponse;
}());
export { GetRiskProfilesResponse };
var GetPortfoliosGivenRiskResponse = /** @class */ (function () {
    function GetPortfoliosGivenRiskResponse(init) {
        Object.assign(this, init);
    }
    return GetPortfoliosGivenRiskResponse;
}());
export { GetPortfoliosGivenRiskResponse };
var GetPortfoliosResponse = /** @class */ (function () {
    function GetPortfoliosResponse(init) {
        Object.assign(this, init);
    }
    return GetPortfoliosResponse;
}());
export { GetPortfoliosResponse };
var GetPortfolioResponse = /** @class */ (function () {
    function GetPortfolioResponse(init) {
        Object.assign(this, init);
    }
    return GetPortfolioResponse;
}());
export { GetPortfolioResponse };
var SessionInfoResponse = /** @class */ (function () {
    function SessionInfoResponse(init) {
        Object.assign(this, init);
    }
    return SessionInfoResponse;
}());
export { SessionInfoResponse };
var RequestSignatureResponse = /** @class */ (function () {
    function RequestSignatureResponse(init) {
        Object.assign(this, init);
    }
    return RequestSignatureResponse;
}());
export { RequestSignatureResponse };
var GetSigningStatusResponse = /** @class */ (function () {
    function GetSigningStatusResponse(init) {
        Object.assign(this, init);
    }
    return GetSigningStatusResponse;
}());
export { GetSigningStatusResponse };
var HelloResponse = /** @class */ (function () {
    function HelloResponse(init) {
        Object.assign(this, init);
    }
    return HelloResponse;
}());
export { HelloResponse };
var TestHelloResponse = /** @class */ (function () {
    function TestHelloResponse(init) {
        Object.assign(this, init);
    }
    return TestHelloResponse;
}());
export { TestHelloResponse };
var GetPartnerSettingsResponse = /** @class */ (function () {
    function GetPartnerSettingsResponse(init) {
        Object.assign(this, init);
    }
    return GetPartnerSettingsResponse;
}());
export { GetPartnerSettingsResponse };
var UpdatePartnerSettingsResponse = /** @class */ (function () {
    function UpdatePartnerSettingsResponse(init) {
        Object.assign(this, init);
    }
    return UpdatePartnerSettingsResponse;
}());
export { UpdatePartnerSettingsResponse };
var UpdatePartnerDefaultSettingsResponse = /** @class */ (function () {
    function UpdatePartnerDefaultSettingsResponse(init) {
        Object.assign(this, init);
    }
    return UpdatePartnerDefaultSettingsResponse;
}());
export { UpdatePartnerDefaultSettingsResponse };
var GetPartnerFeeResponse = /** @class */ (function () {
    function GetPartnerFeeResponse(init) {
        Object.assign(this, init);
    }
    return GetPartnerFeeResponse;
}());
export { GetPartnerFeeResponse };
var SavePartnerFeeResponse = /** @class */ (function () {
    function SavePartnerFeeResponse(init) {
        Object.assign(this, init);
    }
    return SavePartnerFeeResponse;
}());
export { SavePartnerFeeResponse };
var GetPortfolioFeeResponse = /** @class */ (function () {
    function GetPortfolioFeeResponse(init) {
        Object.assign(this, init);
    }
    return GetPortfolioFeeResponse;
}());
export { GetPortfolioFeeResponse };
var SavePortfolioFeeResponse = /** @class */ (function () {
    function SavePortfolioFeeResponse(init) {
        Object.assign(this, init);
    }
    return SavePortfolioFeeResponse;
}());
export { SavePortfolioFeeResponse };
var CalculateFeeResponse = /** @class */ (function () {
    function CalculateFeeResponse(init) {
        Object.assign(this, init);
    }
    return CalculateFeeResponse;
}());
export { CalculateFeeResponse };
var RunMsSimulationResponse = /** @class */ (function () {
    function RunMsSimulationResponse(init) {
        Object.assign(this, init);
    }
    return RunMsSimulationResponse;
}());
export { RunMsSimulationResponse };
var GetTaxInfoResponse = /** @class */ (function () {
    function GetTaxInfoResponse(init) {
        Object.assign(this, init);
    }
    return GetTaxInfoResponse;
}());
export { GetTaxInfoResponse };
var GetUserMessagesResponse = /** @class */ (function () {
    function GetUserMessagesResponse(init) {
        Object.assign(this, init);
    }
    return GetUserMessagesResponse;
}());
export { GetUserMessagesResponse };
var UpdateUserPasswordResponse = /** @class */ (function () {
    function UpdateUserPasswordResponse(init) {
        Object.assign(this, init);
    }
    return UpdateUserPasswordResponse;
}());
export { UpdateUserPasswordResponse };
var SearchAuth0UsersResponse = /** @class */ (function () {
    function SearchAuth0UsersResponse(init) {
        Object.assign(this, init);
    }
    return SearchAuth0UsersResponse;
}());
export { SearchAuth0UsersResponse };
var DeleteAuth0UserResponse = /** @class */ (function () {
    function DeleteAuth0UserResponse(init) {
        Object.assign(this, init);
    }
    return DeleteAuth0UserResponse;
}());
export { DeleteAuth0UserResponse };
var AddUserResponse = /** @class */ (function () {
    function AddUserResponse(init) {
        Object.assign(this, init);
    }
    return AddUserResponse;
}());
export { AddUserResponse };
var GetUserInfoResponse = /** @class */ (function () {
    function GetUserInfoResponse(init) {
        Object.assign(this, init);
    }
    return GetUserInfoResponse;
}());
export { GetUserInfoResponse };
var ShowWelcomeTourResponse = /** @class */ (function () {
    function ShowWelcomeTourResponse(init) {
        Object.assign(this, init);
    }
    return ShowWelcomeTourResponse;
}());
export { ShowWelcomeTourResponse };
var PostWelcomeEndTourResponse = /** @class */ (function () {
    function PostWelcomeEndTourResponse(init) {
        Object.assign(this, init);
    }
    return PostWelcomeEndTourResponse;
}());
export { PostWelcomeEndTourResponse };
var GetSelectedPartnerResponse = /** @class */ (function () {
    function GetSelectedPartnerResponse(init) {
        Object.assign(this, init);
    }
    return GetSelectedPartnerResponse;
}());
export { GetSelectedPartnerResponse };
var ChangePartnerResponse = /** @class */ (function () {
    function ChangePartnerResponse(init) {
        Object.assign(this, init);
    }
    return ChangePartnerResponse;
}());
export { ChangePartnerResponse };
// @DataContract
var RegisterResponse = /** @class */ (function () {
    function RegisterResponse(init) {
        Object.assign(this, init);
    }
    return RegisterResponse;
}());
export { RegisterResponse };
var DeleteUserResponse = /** @class */ (function () {
    function DeleteUserResponse(init) {
        Object.assign(this, init);
    }
    return DeleteUserResponse;
}());
export { DeleteUserResponse };
var UpdateUserSignatureResponse = /** @class */ (function () {
    function UpdateUserSignatureResponse(init) {
        Object.assign(this, init);
    }
    return UpdateUserSignatureResponse;
}());
export { UpdateUserSignatureResponse };
var GetUsersResponse = /** @class */ (function () {
    function GetUsersResponse(init) {
        Object.assign(this, init);
    }
    return GetUsersResponse;
}());
export { GetUsersResponse };
var AssignRoleResponse = /** @class */ (function () {
    function AssignRoleResponse(init) {
        Object.assign(this, init);
    }
    return AssignRoleResponse;
}());
export { AssignRoleResponse };
var UnAssignAllPermissionsResponse = /** @class */ (function () {
    function UnAssignAllPermissionsResponse(init) {
        Object.assign(this, init);
    }
    return UnAssignAllPermissionsResponse;
}());
export { UnAssignAllPermissionsResponse };
var UnAssignRoleResponse = /** @class */ (function () {
    function UnAssignRoleResponse(init) {
        Object.assign(this, init);
    }
    return UnAssignRoleResponse;
}());
export { UnAssignRoleResponse };
// @DataContract
var AuthenticateResponse = /** @class */ (function () {
    function AuthenticateResponse(init) {
        Object.assign(this, init);
    }
    return AuthenticateResponse;
}());
export { AuthenticateResponse };
// @DataContract
var AssignRolesResponse = /** @class */ (function () {
    function AssignRolesResponse(init) {
        Object.assign(this, init);
    }
    return AssignRolesResponse;
}());
export { AssignRolesResponse };
// @DataContract
var UnAssignRolesResponse = /** @class */ (function () {
    function UnAssignRolesResponse(init) {
        Object.assign(this, init);
    }
    return UnAssignRolesResponse;
}());
export { UnAssignRolesResponse };
// @DataContract
var ConvertSessionToTokenResponse = /** @class */ (function () {
    function ConvertSessionToTokenResponse(init) {
        Object.assign(this, init);
    }
    return ConvertSessionToTokenResponse;
}());
export { ConvertSessionToTokenResponse };
// @DataContract
var GetAccessTokenResponse = /** @class */ (function () {
    function GetAccessTokenResponse(init) {
        Object.assign(this, init);
    }
    return GetAccessTokenResponse;
}());
export { GetAccessTokenResponse };
// @Route("/test/fullreport")
var ProduceTestFullReport = /** @class */ (function () {
    function ProduceTestFullReport(init) {
        Object.assign(this, init);
    }
    ProduceTestFullReport.prototype.createResponse = function () { return new ProduceTestReportResponse(); };
    ProduceTestFullReport.prototype.getTypeName = function () { return 'ProduceTestFullReport'; };
    return ProduceTestFullReport;
}());
export { ProduceTestFullReport };
// @Route("/animation", "POST")
var PostAnimation = /** @class */ (function () {
    function PostAnimation(init) {
        Object.assign(this, init);
    }
    PostAnimation.prototype.createResponse = function () { return new PostAnimationResponse(); };
    PostAnimation.prototype.getTypeName = function () { return 'PostAnimation'; };
    return PostAnimation;
}());
export { PostAnimation };
// @Route("/animation/adobe")
var PostPlanToAdobe = /** @class */ (function () {
    function PostPlanToAdobe(init) {
        Object.assign(this, init);
    }
    PostPlanToAdobe.prototype.createResponse = function () { return new PostPlanToAdobeResponse(); };
    PostPlanToAdobe.prototype.getTypeName = function () { return 'PostPlanToAdobe'; };
    return PostPlanToAdobe;
}());
export { PostPlanToAdobe };
// @Route("/secret/userapikeys")
var GetUserApiKeys = /** @class */ (function () {
    function GetUserApiKeys(init) {
        Object.assign(this, init);
    }
    GetUserApiKeys.prototype.createResponse = function () { return new GetUserApiKeysResponse(); };
    GetUserApiKeys.prototype.getTypeName = function () { return 'GetUserApiKeys'; };
    return GetUserApiKeys;
}());
export { GetUserApiKeys };
// @Route("/v2/accounts")
var GetInvestmentAccounts = /** @class */ (function () {
    function GetInvestmentAccounts(init) {
        Object.assign(this, init);
    }
    GetInvestmentAccounts.prototype.createResponse = function () { return new GetInvestmentAccountsResponse(); };
    GetInvestmentAccounts.prototype.getTypeName = function () { return 'GetInvestmentAccounts'; };
    return GetInvestmentAccounts;
}());
export { GetInvestmentAccounts };
// @Route("/v2/clients")
var GetClientsV2 = /** @class */ (function () {
    function GetClientsV2(init) {
        Object.assign(this, init);
    }
    GetClientsV2.prototype.createResponse = function () { return new GetClientsV2Response(); };
    GetClientsV2.prototype.getTypeName = function () { return 'GetClientsV2'; };
    return GetClientsV2;
}());
export { GetClientsV2 };
// @Route("/v2/clients/{Id}")
var GetClientV2 = /** @class */ (function () {
    function GetClientV2(init) {
        Object.assign(this, init);
    }
    GetClientV2.prototype.createResponse = function () { return new GetClientV2Response(); };
    GetClientV2.prototype.getTypeName = function () { return 'GetClientV2'; };
    return GetClientV2;
}());
export { GetClientV2 };
// @Route("/v2/clients/create")
var CreateOrUpdateClientV2 = /** @class */ (function () {
    function CreateOrUpdateClientV2(init) {
        Object.assign(this, init);
    }
    CreateOrUpdateClientV2.prototype.createResponse = function () { return new CreateOrUpdateClientV2Response(); };
    CreateOrUpdateClientV2.prototype.getTypeName = function () { return 'CreateOrUpdateClientV2'; };
    return CreateOrUpdateClientV2;
}());
export { CreateOrUpdateClientV2 };
// @Route("/v2/clients/delete")
var DeleteClientV2 = /** @class */ (function () {
    function DeleteClientV2(init) {
        Object.assign(this, init);
    }
    DeleteClientV2.prototype.createResponse = function () { return new CreateOrUpdateClientV2Response(); };
    DeleteClientV2.prototype.getTypeName = function () { return 'DeleteClientV2'; };
    return DeleteClientV2;
}());
export { DeleteClientV2 };
// @Route("/customportfolios")
var GetCustomPortfolios = /** @class */ (function () {
    function GetCustomPortfolios(init) {
        Object.assign(this, init);
    }
    GetCustomPortfolios.prototype.createResponse = function () { return new GetCustomPortfoliosResponse(); };
    GetCustomPortfolios.prototype.getTypeName = function () { return 'GetCustomPortfolios'; };
    return GetCustomPortfolios;
}());
export { GetCustomPortfolios };
// @Route("/customportfolios/edit/")
var GetCustomPortfolio = /** @class */ (function () {
    function GetCustomPortfolio(init) {
        Object.assign(this, init);
    }
    GetCustomPortfolio.prototype.createResponse = function () { return new GetCustomPortfolioResponse(); };
    GetCustomPortfolio.prototype.getTypeName = function () { return 'GetCustomPortfolio'; };
    return GetCustomPortfolio;
}());
export { GetCustomPortfolio };
// @Route("/customportfolios/stats/")
var CalculateCustomPortfolioStats = /** @class */ (function () {
    function CalculateCustomPortfolioStats(init) {
        Object.assign(this, init);
    }
    CalculateCustomPortfolioStats.prototype.createResponse = function () { return new CalculateCustomPortfolioStatsResponse(); };
    CalculateCustomPortfolioStats.prototype.getTypeName = function () { return 'CalculateCustomPortfolioStats'; };
    return CalculateCustomPortfolioStats;
}());
export { CalculateCustomPortfolioStats };
// @Route("/customportfolios/update/{Id}")
var CreateOrUpdateCustomPortfolio = /** @class */ (function () {
    function CreateOrUpdateCustomPortfolio(init) {
        Object.assign(this, init);
    }
    CreateOrUpdateCustomPortfolio.prototype.createResponse = function () { return new CreateOrUpdateCustomPortfolioResponse(); };
    CreateOrUpdateCustomPortfolio.prototype.getTypeName = function () { return 'CreateOrUpdateCustomPortfolio'; };
    return CreateOrUpdateCustomPortfolio;
}());
export { CreateOrUpdateCustomPortfolio };
// @Route("/mail/template")
var SendMailTemplate = /** @class */ (function () {
    function SendMailTemplate(init) {
        Object.assign(this, init);
    }
    SendMailTemplate.prototype.createResponse = function () { return new SendMailTemplateResponse(); };
    SendMailTemplate.prototype.getTypeName = function () { return 'SendMailTemplate'; };
    return SendMailTemplate;
}());
export { SendMailTemplate };
// @Route("/mail/template/quickerror")
var SendQuickErrorMailTemplate = /** @class */ (function () {
    function SendQuickErrorMailTemplate(init) {
        Object.assign(this, init);
    }
    SendQuickErrorMailTemplate.prototype.createResponse = function () { return new SendQuickErrorMailTemplateResponse(); };
    SendQuickErrorMailTemplate.prototype.getTypeName = function () { return 'SendQuickErrorMailTemplate'; };
    return SendQuickErrorMailTemplate;
}());
export { SendQuickErrorMailTemplate };
// @Route("/mail/test/template")
var SendTempPostmarkMailTemplate = /** @class */ (function () {
    function SendTempPostmarkMailTemplate(init) {
        Object.assign(this, init);
    }
    SendTempPostmarkMailTemplate.prototype.createResponse = function () { return new SendMailTemplateResponse(); };
    SendTempPostmarkMailTemplate.prototype.getTypeName = function () { return 'SendTempPostmarkMailTemplate'; };
    return SendTempPostmarkMailTemplate;
}());
export { SendTempPostmarkMailTemplate };
// @Route("/historical/balances")
var GetHistorical = /** @class */ (function () {
    function GetHistorical(init) {
        Object.assign(this, init);
    }
    GetHistorical.prototype.createResponse = function () { return new GetHistoricalResponse(); };
    GetHistorical.prototype.getTypeName = function () { return 'GetHistorical'; };
    return GetHistorical;
}());
export { GetHistorical };
// @Route("/historical/cashflow")
var GetHistoricalCashFlow = /** @class */ (function () {
    function GetHistoricalCashFlow(init) {
        Object.assign(this, init);
    }
    GetHistoricalCashFlow.prototype.createResponse = function () { return new GetHistoricalCashFlowResponse(); };
    GetHistoricalCashFlow.prototype.getTypeName = function () { return 'GetHistoricalCashFlow'; };
    return GetHistoricalCashFlow;
}());
export { GetHistoricalCashFlow };
// @Route("/demo/animation")
var GetDemoAnimationData = /** @class */ (function () {
    function GetDemoAnimationData(init) {
        Object.assign(this, init);
    }
    GetDemoAnimationData.prototype.createResponse = function () { return new GetProjectionResponse(); };
    GetDemoAnimationData.prototype.getTypeName = function () { return 'GetDemoAnimationData'; };
    return GetDemoAnimationData;
}());
export { GetDemoAnimationData };
// @Route("/management/partners")
var GetPartnersM = /** @class */ (function () {
    function GetPartnersM(init) {
        Object.assign(this, init);
    }
    GetPartnersM.prototype.createResponse = function () { return new GetPartnersResponseM(); };
    GetPartnersM.prototype.getTypeName = function () { return 'GetPartnersM'; };
    return GetPartnersM;
}());
export { GetPartnersM };
// @Route("/management/portfolios")
var GetPortfoliosM = /** @class */ (function () {
    function GetPortfoliosM(init) {
        Object.assign(this, init);
    }
    GetPortfoliosM.prototype.createResponse = function () { return new GetPortfoliosResponseM(); };
    GetPortfoliosM.prototype.getTypeName = function () { return 'GetPortfoliosM'; };
    return GetPortfoliosM;
}());
export { GetPortfoliosM };
// @Route("/management/changePartner")
var ChangePartnerM = /** @class */ (function () {
    function ChangePartnerM(init) {
        Object.assign(this, init);
    }
    ChangePartnerM.prototype.createResponse = function () { return new ChangePartnerResponseM(); };
    ChangePartnerM.prototype.getTypeName = function () { return 'ChangePartnerM'; };
    return ChangePartnerM;
}());
export { ChangePartnerM };
// @Route("/management/themes")
var GetThemesM = /** @class */ (function () {
    function GetThemesM(init) {
        Object.assign(this, init);
    }
    GetThemesM.prototype.createResponse = function () { return new GetThemesResponseM(); };
    GetThemesM.prototype.getTypeName = function () { return 'GetThemesM'; };
    return GetThemesM;
}());
export { GetThemesM };
// @Route("/management/themes/update")
var UpdateThemeM = /** @class */ (function () {
    function UpdateThemeM(init) {
        Object.assign(this, init);
    }
    UpdateThemeM.prototype.createResponse = function () { return new UpdateThemeResponseM(); };
    UpdateThemeM.prototype.getTypeName = function () { return 'UpdateThemeM'; };
    return UpdateThemeM;
}());
export { UpdateThemeM };
// @Route("/v2/partner/proposals")
var GetProposalsV2 = /** @class */ (function () {
    function GetProposalsV2(init) {
        Object.assign(this, init);
    }
    GetProposalsV2.prototype.createResponse = function () { return new GetProposalsV2Response(); };
    GetProposalsV2.prototype.getTypeName = function () { return 'GetProposalsV2'; };
    return GetProposalsV2;
}());
export { GetProposalsV2 };
// @Route("/v2/partner/proposals/audit")
var GetProposalsAuditV2 = /** @class */ (function () {
    function GetProposalsAuditV2(init) {
        Object.assign(this, init);
    }
    GetProposalsAuditV2.prototype.createResponse = function () { return new GetProposalsAuditV2Response(); };
    GetProposalsAuditV2.prototype.getTypeName = function () { return 'GetProposalsAuditV2'; };
    return GetProposalsAuditV2;
}());
export { GetProposalsAuditV2 };
// @Route("/v2/client/proposals/create")
var CreateClientProposalsV2 = /** @class */ (function () {
    function CreateClientProposalsV2(init) {
        Object.assign(this, init);
    }
    CreateClientProposalsV2.prototype.createResponse = function () { return new CreateClientProposalsV2Response(); };
    CreateClientProposalsV2.prototype.getTypeName = function () { return 'CreateClientProposalsV2'; };
    return CreateClientProposalsV2;
}());
export { CreateClientProposalsV2 };
// @Route("/v2/client/proposals/updatestatus")
var UpdateProposalStatusV2 = /** @class */ (function () {
    function UpdateProposalStatusV2(init) {
        Object.assign(this, init);
    }
    UpdateProposalStatusV2.prototype.createResponse = function () { return new UpdateProposalStatusV2Response(); };
    UpdateProposalStatusV2.prototype.getTypeName = function () { return 'UpdateProposalStatusV2'; };
    return UpdateProposalStatusV2;
}());
export { UpdateProposalStatusV2 };
// @Route("/v2/client/proposals/delete")
var DeleteProposalsV2 = /** @class */ (function () {
    function DeleteProposalsV2(init) {
        Object.assign(this, init);
    }
    DeleteProposalsV2.prototype.createResponse = function () { return new DeleteProposalsV2Response(); };
    DeleteProposalsV2.prototype.getTypeName = function () { return 'DeleteProposalsV2'; };
    return DeleteProposalsV2;
}());
export { DeleteProposalsV2 };
// @Route("/v2/auth/client/proposals")
var GetAuthenticatedClientProposalsV2 = /** @class */ (function () {
    function GetAuthenticatedClientProposalsV2(init) {
        Object.assign(this, init);
    }
    GetAuthenticatedClientProposalsV2.prototype.createResponse = function () { return new GetClientProposalsV2Response(); };
    GetAuthenticatedClientProposalsV2.prototype.getTypeName = function () { return 'GetAuthenticatedClientProposalsV2'; };
    return GetAuthenticatedClientProposalsV2;
}());
export { GetAuthenticatedClientProposalsV2 };
// @Route("/v2/client/proposals")
var GetClientProposalsV2 = /** @class */ (function () {
    function GetClientProposalsV2(init) {
        Object.assign(this, init);
    }
    GetClientProposalsV2.prototype.createResponse = function () { return new GetClientProposalsV2Response(); };
    GetClientProposalsV2.prototype.getTypeName = function () { return 'GetClientProposalsV2'; };
    return GetClientProposalsV2;
}());
export { GetClientProposalsV2 };
// @Route("/v2/client/proposals/goal")
var GetClientProposalPlanV2 = /** @class */ (function () {
    function GetClientProposalPlanV2(init) {
        Object.assign(this, init);
    }
    GetClientProposalPlanV2.prototype.createResponse = function () { return new GetClientProposalGoalV2Response(); };
    GetClientProposalPlanV2.prototype.getTypeName = function () { return 'GetClientProposalPlanV2'; };
    return GetClientProposalPlanV2;
}());
export { GetClientProposalPlanV2 };
// @Route("/v2/client/proposals/sign")
var ClientSignProposalsV2 = /** @class */ (function () {
    function ClientSignProposalsV2(init) {
        Object.assign(this, init);
    }
    ClientSignProposalsV2.prototype.createResponse = function () { return new SignProposalsV2Response(); };
    ClientSignProposalsV2.prototype.getTypeName = function () { return 'ClientSignProposalsV2'; };
    return ClientSignProposalsV2;
}());
export { ClientSignProposalsV2 };
// @Route("/v2/client/proposals/download")
var DownloadProposalPlan = /** @class */ (function () {
    function DownloadProposalPlan(init) {
        Object.assign(this, init);
    }
    DownloadProposalPlan.prototype.createResponse = function () { return new DownloadProposalPlanResponse(); };
    DownloadProposalPlan.prototype.getTypeName = function () { return 'DownloadProposalPlan'; };
    return DownloadProposalPlan;
}());
export { DownloadProposalPlan };
// @Route("/mdd", "GET")
var GetMddData = /** @class */ (function () {
    function GetMddData(init) {
        Object.assign(this, init);
    }
    GetMddData.prototype.createResponse = function () { return new GetMddDataResponse(); };
    GetMddData.prototype.getTypeName = function () { return 'GetMddData'; };
    return GetMddData;
}());
export { GetMddData };
// @Route("/projections/stats")
var GetProjectionStats = /** @class */ (function () {
    function GetProjectionStats(init) {
        Object.assign(this, init);
    }
    GetProjectionStats.prototype.createResponse = function () { return new GetProjectionStatsResponse(); };
    GetProjectionStats.prototype.getTypeName = function () { return 'GetProjectionStats'; };
    return GetProjectionStats;
}());
export { GetProjectionStats };
// @Route("/projections/additionalincome")
var AdditionalGetIncomeCashFlowRequest = /** @class */ (function () {
    function AdditionalGetIncomeCashFlowRequest(init) {
        Object.assign(this, init);
    }
    AdditionalGetIncomeCashFlowRequest.prototype.createResponse = function () { return new GetIncomeCashFlowResponse(); };
    AdditionalGetIncomeCashFlowRequest.prototype.getTypeName = function () { return 'AdditionalGetIncomeCashFlowRequest'; };
    return AdditionalGetIncomeCashFlowRequest;
}());
export { AdditionalGetIncomeCashFlowRequest };
// @Route("/projections/additionalcontribution")
var AdditionalGetContributionCashFlowRequest = /** @class */ (function () {
    function AdditionalGetContributionCashFlowRequest(init) {
        Object.assign(this, init);
    }
    AdditionalGetContributionCashFlowRequest.prototype.createResponse = function () { return new GetContributionCashFlowResponse(); };
    AdditionalGetContributionCashFlowRequest.prototype.getTypeName = function () { return 'AdditionalGetContributionCashFlowRequest'; };
    return AdditionalGetContributionCashFlowRequest;
}());
export { AdditionalGetContributionCashFlowRequest };
// @Route("/projections/save")
var SaveProjection = /** @class */ (function () {
    function SaveProjection(init) {
        Object.assign(this, init);
    }
    SaveProjection.prototype.createResponse = function () { return new SaveProjectionResponse(); };
    SaveProjection.prototype.getTypeName = function () { return 'SaveProjection'; };
    return SaveProjection;
}());
export { SaveProjection };
// @Route("/projections/get")
var GetSavedProjection = /** @class */ (function () {
    function GetSavedProjection(init) {
        Object.assign(this, init);
    }
    GetSavedProjection.prototype.createResponse = function () { return new GetSavedProjectionResponse(); };
    GetSavedProjection.prototype.getTypeName = function () { return 'GetSavedProjection'; };
    return GetSavedProjection;
}());
export { GetSavedProjection };
// @Route("/proposals")
var GetProposals = /** @class */ (function () {
    function GetProposals(init) {
        Object.assign(this, init);
    }
    GetProposals.prototype.createResponse = function () { return new GetProposalsResponse(); };
    GetProposals.prototype.getTypeName = function () { return 'GetProposals'; };
    return GetProposals;
}());
export { GetProposals };
// @Route("/clients/documents")
var GetClientDocuments = /** @class */ (function () {
    function GetClientDocuments(init) {
        Object.assign(this, init);
    }
    GetClientDocuments.prototype.createResponse = function () { return new GetClientDocumentsResponse(); };
    GetClientDocuments.prototype.getTypeName = function () { return 'GetClientDocuments'; };
    return GetClientDocuments;
}());
export { GetClientDocuments };
// @Route("/feedback")
var SendFeedback = /** @class */ (function () {
    function SendFeedback(init) {
        Object.assign(this, init);
    }
    SendFeedback.prototype.createResponse = function () { return new SendFeedbackResponse(); };
    SendFeedback.prototype.getTypeName = function () { return 'SendFeedback'; };
    return SendFeedback;
}());
export { SendFeedback };
// @Route("/pdf/download")
var GetPdf = /** @class */ (function () {
    function GetPdf(init) {
        Object.assign(this, init);
    }
    GetPdf.prototype.createResponse = function () { return new Uint8Array(0); };
    GetPdf.prototype.getTypeName = function () { return 'GetPdf'; };
    return GetPdf;
}());
export { GetPdf };
// @Route("/pdf/generate")
var GenerateReport = /** @class */ (function () {
    function GenerateReport(init) {
        Object.assign(this, init);
    }
    GenerateReport.prototype.createResponse = function () { return new GenerateReportResponse(); };
    GenerateReport.prototype.getTypeName = function () { return 'GenerateReport'; };
    return GenerateReport;
}());
export { GenerateReport };
// @Route("/pdf/teststream")
var GetTestReport = /** @class */ (function () {
    function GetTestReport(init) {
        Object.assign(this, init);
    }
    GetTestReport.prototype.createResponse = function () { return new Blob(); };
    GetTestReport.prototype.getTypeName = function () { return 'GetTestReport'; };
    return GetTestReport;
}());
export { GetTestReport };
// @Route("/pdf/downloadstream")
var GetStreamReport = /** @class */ (function () {
    function GetStreamReport(init) {
        Object.assign(this, init);
    }
    GetStreamReport.prototype.createResponse = function () { return new Blob(); };
    GetStreamReport.prototype.getTypeName = function () { return 'GetStreamReport'; };
    return GetStreamReport;
}());
export { GetStreamReport };
// @Route("/pdf/downloadpptstream")
var GetPowerpointReport = /** @class */ (function () {
    function GetPowerpointReport(init) {
        Object.assign(this, init);
    }
    GetPowerpointReport.prototype.createResponse = function () { return new Blob(); };
    GetPowerpointReport.prototype.getTypeName = function () { return 'GetPowerpointReport'; };
    return GetPowerpointReport;
}());
export { GetPowerpointReport };
// @Route("/report/data")
var GetReportData = /** @class */ (function () {
    function GetReportData(init) {
        Object.assign(this, init);
    }
    GetReportData.prototype.createResponse = function () { return new GetReportDataResponse(); };
    GetReportData.prototype.getTypeName = function () { return 'GetReportData'; };
    return GetReportData;
}());
export { GetReportData };
// @Route("/calculator/aa")
var CalculatePortfolioAa = /** @class */ (function () {
    function CalculatePortfolioAa(init) {
        Object.assign(this, init);
    }
    CalculatePortfolioAa.prototype.createResponse = function () { return new CalculatePortfolioAaResponse(); };
    CalculatePortfolioAa.prototype.getTypeName = function () { return 'CalculatePortfolioAa'; };
    return CalculatePortfolioAa;
}());
export { CalculatePortfolioAa };
// @Route("/calculator/statsAa")
var CalculatePortfolioStatsBasedOnAa = /** @class */ (function () {
    function CalculatePortfolioStatsBasedOnAa(init) {
        Object.assign(this, init);
    }
    CalculatePortfolioStatsBasedOnAa.prototype.createResponse = function () { return new CalculatePortfolioStatsResponse(); };
    CalculatePortfolioStatsBasedOnAa.prototype.getTypeName = function () { return 'CalculatePortfolioStatsBasedOnAa'; };
    return CalculatePortfolioStatsBasedOnAa;
}());
export { CalculatePortfolioStatsBasedOnAa };
// @Route("/calculator/statsAa/update")
var UpdatePortfolioStatsBasedOnAa = /** @class */ (function () {
    function UpdatePortfolioStatsBasedOnAa(init) {
        Object.assign(this, init);
    }
    UpdatePortfolioStatsBasedOnAa.prototype.createResponse = function () { return new UpdatePortfolioStatsBasedOnAaResponse(); };
    UpdatePortfolioStatsBasedOnAa.prototype.getTypeName = function () { return 'UpdatePortfolioStatsBasedOnAa'; };
    return UpdatePortfolioStatsBasedOnAa;
}());
export { UpdatePortfolioStatsBasedOnAa };
// @Route("/sustainableIncome")
var CalculateSustainableIncome = /** @class */ (function () {
    function CalculateSustainableIncome(init) {
        Object.assign(this, init);
    }
    CalculateSustainableIncome.prototype.createResponse = function () { return new CalculateSustainableIncomeResponse(); };
    CalculateSustainableIncome.prototype.getTypeName = function () { return 'CalculateSustainableIncome'; };
    return CalculateSustainableIncome;
}());
export { CalculateSustainableIncome };
// @Route("/calculator/optimalportfolio")
var CalculateOptimalPortfolio = /** @class */ (function () {
    function CalculateOptimalPortfolio(init) {
        Object.assign(this, init);
    }
    CalculateOptimalPortfolio.prototype.createResponse = function () { return new CalculateOptimalPortfolioResponse(); };
    CalculateOptimalPortfolio.prototype.getTypeName = function () { return 'CalculateOptimalPortfolio'; };
    return CalculateOptimalPortfolio;
}());
export { CalculateOptimalPortfolio };
// @Route("/calculator/postretirement")
var CalculatePostRetirement = /** @class */ (function () {
    function CalculatePostRetirement(init) {
        Object.assign(this, init);
    }
    CalculatePostRetirement.prototype.createResponse = function () { return new CalculateProjectedBalancesResponse(); };
    CalculatePostRetirement.prototype.getTypeName = function () { return 'CalculatePostRetirement'; };
    return CalculatePostRetirement;
}());
export { CalculatePostRetirement };
// @Route("/calculator/projectedReturns")
var CalculateProjectedReturnsV2 = /** @class */ (function () {
    function CalculateProjectedReturnsV2(init) {
        Object.assign(this, init);
    }
    CalculateProjectedReturnsV2.prototype.createResponse = function () { return new CalculateProjectedReturnsResponse(); };
    CalculateProjectedReturnsV2.prototype.getTypeName = function () { return 'CalculateProjectedReturnsV2'; };
    return CalculateProjectedReturnsV2;
}());
export { CalculateProjectedReturnsV2 };
// @Route("/clients")
var GetClients = /** @class */ (function () {
    function GetClients(init) {
        Object.assign(this, init);
    }
    GetClients.prototype.createResponse = function () { return new GetClientsResponse(); };
    GetClients.prototype.getTypeName = function () { return 'GetClients'; };
    return GetClients;
}());
export { GetClients };
// @Route("/clients/{Id}")
var GetClient = /** @class */ (function () {
    function GetClient(init) {
        Object.assign(this, init);
    }
    GetClient.prototype.createResponse = function () { return new GetClientResponse(); };
    GetClient.prototype.getTypeName = function () { return 'GetClient'; };
    return GetClient;
}());
export { GetClient };
// @Route("/clients/create")
var CreateOrUpdateClient = /** @class */ (function () {
    function CreateOrUpdateClient(init) {
        Object.assign(this, init);
    }
    CreateOrUpdateClient.prototype.createResponse = function () { return new CreateOrUpdateClientResponse(); };
    CreateOrUpdateClient.prototype.getTypeName = function () { return 'CreateOrUpdateClient'; };
    return CreateOrUpdateClient;
}());
export { CreateOrUpdateClient };
// @Route("/clients/postretirement/create")
var CreatePostRetirementClient = /** @class */ (function () {
    function CreatePostRetirementClient(init) {
        Object.assign(this, init);
    }
    CreatePostRetirementClient.prototype.createResponse = function () { return new CreatePostRetirementClientResponse(); };
    CreatePostRetirementClient.prototype.getTypeName = function () { return 'CreatePostRetirementClient'; };
    return CreatePostRetirementClient;
}());
export { CreatePostRetirementClient };
// @Route("/goals/types")
var GetGoalTypes = /** @class */ (function () {
    function GetGoalTypes(init) {
        Object.assign(this, init);
    }
    GetGoalTypes.prototype.createResponse = function () { return new GetGoalTypesResponse(); };
    GetGoalTypes.prototype.getTypeName = function () { return 'GetGoalTypes'; };
    return GetGoalTypes;
}());
export { GetGoalTypes };
// @Route("/v2/client/goals/delete")
var DeleteClientGoalsV2 = /** @class */ (function () {
    function DeleteClientGoalsV2(init) {
        Object.assign(this, init);
    }
    DeleteClientGoalsV2.prototype.createResponse = function () { return new UpdateClientGoalsV2Response(); };
    DeleteClientGoalsV2.prototype.getTypeName = function () { return 'DeleteClientGoalsV2'; };
    return DeleteClientGoalsV2;
}());
export { DeleteClientGoalsV2 };
// @Route("/v2/client/goals")
var GetClientGoalsV2 = /** @class */ (function () {
    function GetClientGoalsV2(init) {
        Object.assign(this, init);
    }
    GetClientGoalsV2.prototype.createResponse = function () { return new GetClientGoalsV2Response(); };
    GetClientGoalsV2.prototype.getTypeName = function () { return 'GetClientGoalsV2'; };
    return GetClientGoalsV2;
}());
export { GetClientGoalsV2 };
// @Route("/client/goals")
var GetClientGoals = /** @class */ (function () {
    function GetClientGoals(init) {
        Object.assign(this, init);
    }
    GetClientGoals.prototype.createResponse = function () { return new GetClientGoalsResponse(); };
    GetClientGoals.prototype.getTypeName = function () { return 'GetClientGoals'; };
    return GetClientGoals;
}());
export { GetClientGoals };
// @Route("/goals/retirement/create")
var CreateOrUpdateRetirementGoal = /** @class */ (function () {
    function CreateOrUpdateRetirementGoal(init) {
        Object.assign(this, init);
    }
    CreateOrUpdateRetirementGoal.prototype.createResponse = function () { return new CreateGoalResponse(); };
    CreateOrUpdateRetirementGoal.prototype.getTypeName = function () { return 'CreateOrUpdateRetirementGoal'; };
    return CreateOrUpdateRetirementGoal;
}());
export { CreateOrUpdateRetirementGoal };
// @Route("/goals/results/status")
var UpdatePlanStatus = /** @class */ (function () {
    function UpdatePlanStatus(init) {
        Object.assign(this, init);
    }
    UpdatePlanStatus.prototype.createResponse = function () { return new UpdateGoalResultsStatusResponse(); };
    UpdatePlanStatus.prototype.getTypeName = function () { return 'UpdatePlanStatus'; };
    return UpdatePlanStatus;
}());
export { UpdatePlanStatus };
// @Route("/goals/retirement/results/create")
var CreateOrUpdateRetirementGoalResults = /** @class */ (function () {
    function CreateOrUpdateRetirementGoalResults(init) {
        Object.assign(this, init);
    }
    CreateOrUpdateRetirementGoalResults.prototype.createResponse = function () { return new CreateGoalResponse(); };
    CreateOrUpdateRetirementGoalResults.prototype.getTypeName = function () { return 'CreateOrUpdateRetirementGoalResults'; };
    return CreateOrUpdateRetirementGoalResults;
}());
export { CreateOrUpdateRetirementGoalResults };
// @Route("/goals/retirement/{Id}")
var GetRetirementGoal = /** @class */ (function () {
    function GetRetirementGoal(init) {
        Object.assign(this, init);
    }
    GetRetirementGoal.prototype.createResponse = function () { return new RetirementGoalResponse(); };
    GetRetirementGoal.prototype.getTypeName = function () { return 'GetRetirementGoal'; };
    return GetRetirementGoal;
}());
export { GetRetirementGoal };
// @Route("/riskprofiles/calculate/riskneed")
var GetRiskNeed = /** @class */ (function () {
    function GetRiskNeed(init) {
        Object.assign(this, init);
    }
    GetRiskNeed.prototype.createResponse = function () { return new GetRiskNeedResponse(); };
    GetRiskNeed.prototype.getTypeName = function () { return 'GetRiskNeed'; };
    return GetRiskNeed;
}());
export { GetRiskNeed };
// @Route("/riskprofiles/calculate/riskability")
var GetRiskAbility = /** @class */ (function () {
    function GetRiskAbility(init) {
        Object.assign(this, init);
    }
    GetRiskAbility.prototype.createResponse = function () { return new GetRiskAbilityResponse(); };
    GetRiskAbility.prototype.getTypeName = function () { return 'GetRiskAbility'; };
    return GetRiskAbility;
}());
export { GetRiskAbility };
// @Route("/riskprofiles/calculate/risktolerance")
var GetRiskTolerance = /** @class */ (function () {
    function GetRiskTolerance(init) {
        Object.assign(this, init);
    }
    GetRiskTolerance.prototype.createResponse = function () { return new GetRiskToleranceResponse(); };
    GetRiskTolerance.prototype.getTypeName = function () { return 'GetRiskTolerance'; };
    return GetRiskTolerance;
}());
export { GetRiskTolerance };
// @Route("/riskprofiles/calculate/goalriskprofile")
var GetGoalRiskProfile = /** @class */ (function () {
    function GetGoalRiskProfile(init) {
        Object.assign(this, init);
    }
    GetGoalRiskProfile.prototype.createResponse = function () { return new GetGoalRiskProfileResponse(); };
    GetGoalRiskProfile.prototype.getTypeName = function () { return 'GetGoalRiskProfile'; };
    return GetGoalRiskProfile;
}());
export { GetGoalRiskProfile };
// @Route("/riskprofiles")
var GetRiskProfiles = /** @class */ (function () {
    function GetRiskProfiles(init) {
        Object.assign(this, init);
    }
    GetRiskProfiles.prototype.createResponse = function () { return new GetRiskProfilesResponse(); };
    GetRiskProfiles.prototype.getTypeName = function () { return 'GetRiskProfiles'; };
    return GetRiskProfiles;
}());
export { GetRiskProfiles };
// @Route("/riskprofiles/portfolios")
var GetPortfoliosGivenRisk = /** @class */ (function () {
    function GetPortfoliosGivenRisk(init) {
        Object.assign(this, init);
    }
    GetPortfoliosGivenRisk.prototype.createResponse = function () { return new GetPortfoliosGivenRiskResponse(); };
    GetPortfoliosGivenRisk.prototype.getTypeName = function () { return 'GetPortfoliosGivenRisk'; };
    return GetPortfoliosGivenRisk;
}());
export { GetPortfoliosGivenRisk };
// @Route("/portfolios")
var GetPortfolios = /** @class */ (function () {
    function GetPortfolios(init) {
        Object.assign(this, init);
    }
    GetPortfolios.prototype.createResponse = function () { return new GetPortfoliosResponse(); };
    GetPortfolios.prototype.getTypeName = function () { return 'GetPortfolios'; };
    return GetPortfolios;
}());
export { GetPortfolios };
// @Route("/portfolios/{Id}")
var GetPortfolio = /** @class */ (function () {
    function GetPortfolio(init) {
        Object.assign(this, init);
    }
    GetPortfolio.prototype.createResponse = function () { return new GetPortfolioResponse(); };
    GetPortfolio.prototype.getTypeName = function () { return 'GetPortfolio'; };
    return GetPortfolio;
}());
export { GetPortfolio };
// @Route("/my-session")
var SessionInfo = /** @class */ (function () {
    function SessionInfo(init) {
        Object.assign(this, init);
    }
    SessionInfo.prototype.createResponse = function () { return new SessionInfoResponse(); };
    SessionInfo.prototype.getTypeName = function () { return 'SessionInfo'; };
    return SessionInfo;
}());
export { SessionInfo };
// @Route("/signing/sendrequest")
var SendLivingAnnuitySignatureRequest = /** @class */ (function () {
    function SendLivingAnnuitySignatureRequest(init) {
        Object.assign(this, init);
    }
    SendLivingAnnuitySignatureRequest.prototype.createResponse = function () { return new RequestSignatureResponse(); };
    SendLivingAnnuitySignatureRequest.prototype.getTypeName = function () { return 'SendLivingAnnuitySignatureRequest'; };
    return SendLivingAnnuitySignatureRequest;
}());
export { SendLivingAnnuitySignatureRequest };
// @Route("/signing")
var GetSigningStatus = /** @class */ (function () {
    function GetSigningStatus(init) {
        Object.assign(this, init);
    }
    GetSigningStatus.prototype.createResponse = function () { return new GetSigningStatusResponse(); };
    GetSigningStatus.prototype.getTypeName = function () { return 'GetSigningStatus'; };
    return GetSigningStatus;
}());
export { GetSigningStatus };
// @Route("/hello/{Name}")
var Hello = /** @class */ (function () {
    function Hello(init) {
        Object.assign(this, init);
    }
    Hello.prototype.createResponse = function () { return new HelloResponse(); };
    Hello.prototype.getTypeName = function () { return 'Hello'; };
    return Hello;
}());
export { Hello };
// @Route("/test/hello")
var TestHello = /** @class */ (function () {
    function TestHello(init) {
        Object.assign(this, init);
    }
    TestHello.prototype.createResponse = function () { return new TestHelloResponse(); };
    TestHello.prototype.getTypeName = function () { return 'TestHello'; };
    return TestHello;
}());
export { TestHello };
// @Route("/settings")
var GetPartnerSettings = /** @class */ (function () {
    function GetPartnerSettings(init) {
        Object.assign(this, init);
    }
    GetPartnerSettings.prototype.createResponse = function () { return new GetPartnerSettingsResponse(); };
    GetPartnerSettings.prototype.getTypeName = function () { return 'GetPartnerSettings'; };
    return GetPartnerSettings;
}());
export { GetPartnerSettings };
// @Route("/settings/update")
var UpdatePartnerSettings = /** @class */ (function () {
    function UpdatePartnerSettings(init) {
        Object.assign(this, init);
    }
    UpdatePartnerSettings.prototype.createResponse = function () { return new UpdatePartnerSettingsResponse(); };
    UpdatePartnerSettings.prototype.getTypeName = function () { return 'UpdatePartnerSettings'; };
    return UpdatePartnerSettings;
}());
export { UpdatePartnerSettings };
// @Route("/settings/default/update")
var UpdatePartnerDefaultSettings = /** @class */ (function () {
    function UpdatePartnerDefaultSettings(init) {
        Object.assign(this, init);
    }
    UpdatePartnerDefaultSettings.prototype.createResponse = function () { return new UpdatePartnerDefaultSettingsResponse(); };
    UpdatePartnerDefaultSettings.prototype.getTypeName = function () { return 'UpdatePartnerDefaultSettings'; };
    return UpdatePartnerDefaultSettings;
}());
export { UpdatePartnerDefaultSettings };
// @Route("/fees/partner")
var GetPartnerFee = /** @class */ (function () {
    function GetPartnerFee(init) {
        Object.assign(this, init);
    }
    GetPartnerFee.prototype.createResponse = function () { return new GetPartnerFeeResponse(); };
    GetPartnerFee.prototype.getTypeName = function () { return 'GetPartnerFee'; };
    return GetPartnerFee;
}());
export { GetPartnerFee };
// @Route("/fees/partner/save")
var SavePartnerFee = /** @class */ (function () {
    function SavePartnerFee(init) {
        Object.assign(this, init);
    }
    SavePartnerFee.prototype.createResponse = function () { return new SavePartnerFeeResponse(); };
    SavePartnerFee.prototype.getTypeName = function () { return 'SavePartnerFee'; };
    return SavePartnerFee;
}());
export { SavePartnerFee };
// @Route("/fees/partner/portfolio")
var GetPortfolioFee = /** @class */ (function () {
    function GetPortfolioFee(init) {
        Object.assign(this, init);
    }
    GetPortfolioFee.prototype.createResponse = function () { return new GetPortfolioFeeResponse(); };
    GetPortfolioFee.prototype.getTypeName = function () { return 'GetPortfolioFee'; };
    return GetPortfolioFee;
}());
export { GetPortfolioFee };
// @Route("/fees/partner/portfolio/save")
var SavePortfolioFee = /** @class */ (function () {
    function SavePortfolioFee(init) {
        Object.assign(this, init);
    }
    SavePortfolioFee.prototype.createResponse = function () { return new SavePortfolioFeeResponse(); };
    SavePortfolioFee.prototype.getTypeName = function () { return 'SavePortfolioFee'; };
    return SavePortfolioFee;
}());
export { SavePortfolioFee };
// @Route("/fees")
var CalculateFee = /** @class */ (function () {
    function CalculateFee(init) {
        Object.assign(this, init);
    }
    CalculateFee.prototype.createResponse = function () { return new CalculateFeeResponse(); };
    CalculateFee.prototype.getTypeName = function () { return 'CalculateFee'; };
    return CalculateFee;
}());
export { CalculateFee };
// @Route("/ms/run")
var RunMsSimulation = /** @class */ (function () {
    function RunMsSimulation(init) {
        Object.assign(this, init);
    }
    RunMsSimulation.prototype.createResponse = function () { return new RunMsSimulationResponse(); };
    RunMsSimulation.prototype.getTypeName = function () { return 'RunMsSimulation'; };
    return RunMsSimulation;
}());
export { RunMsSimulation };
// @Route("/tax")
var GetTaxInfo = /** @class */ (function () {
    function GetTaxInfo(init) {
        Object.assign(this, init);
    }
    GetTaxInfo.prototype.createResponse = function () { return new GetTaxInfoResponse(); };
    GetTaxInfo.prototype.getTypeName = function () { return 'GetTaxInfo'; };
    return GetTaxInfo;
}());
export { GetTaxInfo };
// @Route("/messages")
var GetUserMessages = /** @class */ (function () {
    function GetUserMessages(init) {
        Object.assign(this, init);
    }
    GetUserMessages.prototype.createResponse = function () { return new GetUserMessagesResponse(); };
    GetUserMessages.prototype.getTypeName = function () { return 'GetUserMessages'; };
    return GetUserMessages;
}());
export { GetUserMessages };
// @Route("/user/management/password")
var UpdateUserPassword = /** @class */ (function () {
    function UpdateUserPassword(init) {
        Object.assign(this, init);
    }
    UpdateUserPassword.prototype.createResponse = function () { return new UpdateUserPasswordResponse(); };
    UpdateUserPassword.prototype.getTypeName = function () { return 'UpdateUserPassword'; };
    return UpdateUserPassword;
}());
export { UpdateUserPassword };
// @Route("/user/management/search")
var SearchAuth0Users = /** @class */ (function () {
    function SearchAuth0Users(init) {
        Object.assign(this, init);
    }
    SearchAuth0Users.prototype.createResponse = function () { return new SearchAuth0UsersResponse(); };
    SearchAuth0Users.prototype.getTypeName = function () { return 'SearchAuth0Users'; };
    return SearchAuth0Users;
}());
export { SearchAuth0Users };
// @Route("/user/management/search")
var DeleteAuth0User = /** @class */ (function () {
    function DeleteAuth0User(init) {
        Object.assign(this, init);
    }
    DeleteAuth0User.prototype.createResponse = function () { return new DeleteAuth0UserResponse(); };
    DeleteAuth0User.prototype.getTypeName = function () { return 'DeleteAuth0User'; };
    return DeleteAuth0User;
}());
export { DeleteAuth0User };
// @Route("/user/management/create")
var AddUser = /** @class */ (function () {
    function AddUser(init) {
        Object.assign(this, init);
    }
    AddUser.prototype.createResponse = function () { return new AddUserResponse(); };
    AddUser.prototype.getTypeName = function () { return 'AddUser'; };
    return AddUser;
}());
export { AddUser };
// @Route("/userinfo")
var GetUserInfo = /** @class */ (function () {
    function GetUserInfo(init) {
        Object.assign(this, init);
    }
    GetUserInfo.prototype.createResponse = function () { return new GetUserInfoResponse(); };
    GetUserInfo.prototype.getTypeName = function () { return 'GetUserInfo'; };
    return GetUserInfo;
}());
export { GetUserInfo };
// @Route("/welcome")
var ShowWelcomeTour = /** @class */ (function () {
    function ShowWelcomeTour(init) {
        Object.assign(this, init);
    }
    ShowWelcomeTour.prototype.createResponse = function () { return new ShowWelcomeTourResponse(); };
    ShowWelcomeTour.prototype.getTypeName = function () { return 'ShowWelcomeTour'; };
    return ShowWelcomeTour;
}());
export { ShowWelcomeTour };
// @Route("/welcome/end")
var PostWelcomeEndTour = /** @class */ (function () {
    function PostWelcomeEndTour(init) {
        Object.assign(this, init);
    }
    PostWelcomeEndTour.prototype.createResponse = function () { return new PostWelcomeEndTourResponse(); };
    PostWelcomeEndTour.prototype.getTypeName = function () { return 'PostWelcomeEndTour'; };
    return PostWelcomeEndTour;
}());
export { PostWelcomeEndTour };
// @Route("/user/signature")
var GetUserSignature = /** @class */ (function () {
    function GetUserSignature(init) {
        Object.assign(this, init);
    }
    GetUserSignature.prototype.createResponse = function () { return new GetUserInfoResponse(); };
    GetUserSignature.prototype.getTypeName = function () { return 'GetUserSignature'; };
    return GetUserSignature;
}());
export { GetUserSignature };
// @Route("/user/selectedpartner")
var GetSelectedPartner = /** @class */ (function () {
    function GetSelectedPartner(init) {
        Object.assign(this, init);
    }
    GetSelectedPartner.prototype.createResponse = function () { return new GetSelectedPartnerResponse(); };
    GetSelectedPartner.prototype.getTypeName = function () { return 'GetSelectedPartner'; };
    return GetSelectedPartner;
}());
export { GetSelectedPartner };
// @Route("/user/changepartner")
var ChangePartner = /** @class */ (function () {
    function ChangePartner(init) {
        Object.assign(this, init);
    }
    ChangePartner.prototype.createResponse = function () { return new ChangePartnerResponse(); };
    ChangePartner.prototype.getTypeName = function () { return 'ChangePartner'; };
    return ChangePartner;
}());
export { ChangePartner };
// @Route("/users/create", "POST")
var CreateUser = /** @class */ (function () {
    function CreateUser(init) {
        Object.assign(this, init);
    }
    CreateUser.prototype.createResponse = function () { return new RegisterResponse(); };
    CreateUser.prototype.getTypeName = function () { return 'CreateUser'; };
    return CreateUser;
}());
export { CreateUser };
// @Route("/users/delete", "POST")
var DeleteUser = /** @class */ (function () {
    function DeleteUser(init) {
        Object.assign(this, init);
    }
    DeleteUser.prototype.createResponse = function () { return new DeleteUserResponse(); };
    DeleteUser.prototype.getTypeName = function () { return 'DeleteUser'; };
    return DeleteUser;
}());
export { DeleteUser };
// @Route("/users/update")
var UpdateUserSignature = /** @class */ (function () {
    function UpdateUserSignature(init) {
        Object.assign(this, init);
    }
    UpdateUserSignature.prototype.createResponse = function () { return new UpdateUserSignatureResponse(); };
    UpdateUserSignature.prototype.getTypeName = function () { return 'UpdateUserSignature'; };
    return UpdateUserSignature;
}());
export { UpdateUserSignature };
// @Route("/users")
var GetUsers = /** @class */ (function () {
    function GetUsers(init) {
        Object.assign(this, init);
    }
    GetUsers.prototype.createResponse = function () { return new GetUsersResponse(); };
    GetUsers.prototype.getTypeName = function () { return 'GetUsers'; };
    return GetUsers;
}());
export { GetUsers };
// @Route("/users/assignRole", "POST")
var AssignRole = /** @class */ (function () {
    function AssignRole(init) {
        Object.assign(this, init);
    }
    AssignRole.prototype.createResponse = function () { return new AssignRoleResponse(); };
    AssignRole.prototype.getTypeName = function () { return 'AssignRole'; };
    return AssignRole;
}());
export { AssignRole };
// @Route("/users/unassignallpermissions")
var UnAssignAllPermissions = /** @class */ (function () {
    function UnAssignAllPermissions(init) {
        Object.assign(this, init);
    }
    UnAssignAllPermissions.prototype.createResponse = function () { return new UnAssignAllPermissionsResponse(); };
    UnAssignAllPermissions.prototype.getTypeName = function () { return 'UnAssignAllPermissions'; };
    return UnAssignAllPermissions;
}());
export { UnAssignAllPermissions };
// @Route("/users/unAssignRole", "POST")
var UnAssignRole = /** @class */ (function () {
    function UnAssignRole(init) {
        Object.assign(this, init);
    }
    UnAssignRole.prototype.createResponse = function () { return new UnAssignRoleResponse(); };
    UnAssignRole.prototype.getTypeName = function () { return 'UnAssignRole'; };
    return UnAssignRole;
}());
export { UnAssignRole };
// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
var Authenticate = /** @class */ (function () {
    function Authenticate(init) {
        Object.assign(this, init);
    }
    Authenticate.prototype.createResponse = function () { return new AuthenticateResponse(); };
    Authenticate.prototype.getTypeName = function () { return 'Authenticate'; };
    return Authenticate;
}());
export { Authenticate };
// @Route("/assignroles")
// @DataContract
var AssignRoles = /** @class */ (function () {
    function AssignRoles(init) {
        Object.assign(this, init);
    }
    AssignRoles.prototype.createResponse = function () { return new AssignRolesResponse(); };
    AssignRoles.prototype.getTypeName = function () { return 'AssignRoles'; };
    return AssignRoles;
}());
export { AssignRoles };
// @Route("/unassignroles")
// @DataContract
var UnAssignRoles = /** @class */ (function () {
    function UnAssignRoles(init) {
        Object.assign(this, init);
    }
    UnAssignRoles.prototype.createResponse = function () { return new UnAssignRolesResponse(); };
    UnAssignRoles.prototype.getTypeName = function () { return 'UnAssignRoles'; };
    return UnAssignRoles;
}());
export { UnAssignRoles };
// @Route("/session-to-token")
// @DataContract
var ConvertSessionToToken = /** @class */ (function () {
    function ConvertSessionToToken(init) {
        Object.assign(this, init);
    }
    ConvertSessionToToken.prototype.createResponse = function () { return new ConvertSessionToTokenResponse(); };
    ConvertSessionToToken.prototype.getTypeName = function () { return 'ConvertSessionToToken'; };
    return ConvertSessionToToken;
}());
export { ConvertSessionToToken };
// @Route("/access-token")
// @DataContract
var GetAccessToken = /** @class */ (function () {
    function GetAccessToken(init) {
        Object.assign(this, init);
    }
    GetAccessToken.prototype.createResponse = function () { return new GetAccessTokenResponse(); };
    GetAccessToken.prototype.getTypeName = function () { return 'GetAccessToken'; };
    return GetAccessToken;
}());
export { GetAccessToken };
